import {
  GET_ALL_SUPPORT,
  GET_SUPPORT_BY_ID,
  CREATE_SUPPORT,
  UPDATE_SUPPORT,
  DELETE_SUPPORT,
} from "../actions/types";

const initialState = {
  supportList: [],
  selectedSupport: null,
  supportSaveStatus: null,
  supportUpdateStatus: null,
  supportDeleteStatus: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SUPPORT:
      return {
        ...state,
        // id → support_id mapping (announcement jaisa fix)
        supportList: (action.payload.data || []).map((item) => ({
          ...item,
          support_id: item.support_id || item.id,
        })),
      };

    case GET_SUPPORT_BY_ID:
      return {
        ...state,
        selectedSupport: action.payload.data,
      };

    case CREATE_SUPPORT:
      return {
        ...state,
        supportSaveStatus: action.payload.success,
      };

    case UPDATE_SUPPORT:
      return {
        ...state,
        supportUpdateStatus: action.payload.success,
      };

    case DELETE_SUPPORT:
      return {
        ...state,
        supportDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}